export default {
    "packages": [
        {
            "title": "fusion组件库",
            "package": "@alifd/next",
            "version": "1.26.4",
            "urls": [
                "./assets/umd/alifd__next/next.min.css",
                "./assets/umd/alifd__next/next-with-locales.min.js"
            ],
            "library": "Next"
        },
        // {
        //     "package": "@alilc/lowcode-materials",
        //     "version": "1.0.4",
        //     "library": "AlilcLowcodeMaterials",
        //     "urls": [
        //         "https://resource.designer.beflam.com/lowcode-materials/0.0.1/dist/AlilcLowcodeMaterials.js",
        //         "https://resource.designer.beflam.com/lowcode-materials/0.0.1/dist/AlilcLowcodeMaterials.css"
        //     ],
        //     "editUrls": [
        //         "https://resource.designer.beflam.com/lowcode-materials/0.0.1/build/lowcode/view.js",
        //         "https://resource.designer.beflam.com/lowcode-materials/0.0.1/build/lowcode/view.css"
        //     ]
        // },
    ] as any[],
    "components": [] as any[],
    "sort": {
        "groupList": [
            "基础控件",
            "复杂控件",
            "布局控件"
        ],
        "categoryList": []
    },
    "groupList": [],
    "ignoreComponents": {}
}